import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(): boolean | UrlTree {
    // Misma fuente de verdad que authGuard (userEnergiaReal). Usar otra llave causa loop '' <-> '/er'.
    if (this.authService.userValue) return this.router.parseUrl('/er');

    localStorage.removeItem('userInfo');
    return true;
  }
}
